<template>
  <div class="flex flex-wrap lg:flex-no-wrap justify-start items-center custom-upload-file" :class="`size-${size}`">
    <div :id="`upload-container-${id}`" class="relative">
      <div v-if="file.key" class="current-image">
        <div class="current-image__inner">
          <img v-if="type === 'image' && isImage" :src="file.url">
          <div v-else class="file">
            <vs-icon
              class="file__icon"
              icon-pack="feather"
              icon="icon-file-text"
            />
          </div>
          <div class="current-image__cover" @click.prevent="deleteFile">
            <vs-icon icon-pack="feather" icon="icon-trash-2" color="danger"/>
          </div>
        </div>
      </div>

      <div v-else class="upload-file">
        <input type="file" ref="file" @change="uploadFile">
        <div class="upload-file__text">{{ label }}</div>
      </div>
    </div>

    <div class="ml-6">
      <div v-if="file.key">
        <p>{{ file.filename }}</p>
        <p>{{ file.size_human_readable }}</p>
      </div>
      <p v-else v-html="text"></p>
    </div>
  </div>
</template>

<script>
import File from '../api/http/models/File'
import {mapGetters} from 'vuex'

export default {
  name: 'UploadFile',
  props: {
    value: {
      type: String
    },
    type: {
      type: String,
      default: 'image' // image | file
    },
    text: {
      type: String,
      default: 'Допустимые форматы изображения: PNG, JPEG, GIF<br>Максимальный размер загружаемого файла: 2024*2024 px.'
    },
    label: {
      type: String,
      default: 'Фото'
    },
    size: {
      type: String,
      default: 'md' // sm | md
    }
  },
  data () {
    return {
      fileKey: this.value,
      file: {},
      id: ''
    }
  },
  async created () {
    if (this.fileKey) {
      const response = await File.getOne(this.authUserCompany.slug, this.fileKey)

      if (response.data) {
        this.file = response.data
      }
    }
  },
  mounted () {
    this.id = this._uid
  },
  computed: {
    ...mapGetters(['authUserCompany']),
    isImage () {
      return /(jpg|gif|png|JPG|GIF|PNG|JPEG|jpeg)$/.test(this.file.url)
    }
  },
  methods: {
    async uploadFile () {
      const file = this.$refs.file.files[0]
      const sizeInMB = (file.size / (1024 * 1024)).toFixed(2)
      if (sizeInMB >= 3) {
        this.$vs.notify({
          color: 'danger',
          title: 'Размер файла превышает 3MB',
          text: ''
        })
        return false
      }
      await this.$vs.loading({
        container: `#upload-container-${this.id}`,
        type: 'point'
      })
      const formData = new FormData()
      formData.append('file', file)
      const response = await File.upload(this.authUserCompany.slug, formData)
      await this.$vs.loading.close(`#upload-container-${this.id} > .con-vs-loading`)
      if (response.status === 'success') {
        this.file = response.data
        this.fileKey = this.file.key
        this.$emit('input', this.fileKey)
        this.$vs.notify({
          color: 'success',
          title: 'Файл добавлен на сервер',
          text: ''
        })
      } else {
        this.$vs.notify({
          color: 'danger',
          title: 'Произошла ошибка при добавлени файла на сервер',
          text: ''
        })
      }
    },
    deleteFile () {
      this.file = {}
      this.$emit('input', '')
    }
  }
}
</script>

<style lang="scss">
  .upload-file {
    position: relative;
    width: 200px;
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f5f5f5;
    border-radius: 8px;
    border: 1px dashed rgba(0,0,0,.1);
    &:hover {
      border: 1px dashed rgba(var(--vs-primary), .5);
    }
    input {
      position: absolute;
      width: 100%;
      height: 100%;
      opacity: 0;
      left: 0;
      top: 0;
      cursor: pointer;
    }
    &__text {
      min-width: 200px;
      display: block;
      text-align: center;
      margin: 0!important;
      padding: 0!important;
      width: 100%;
      font-weight: 700;
    }
  }
  .current-image {
    &__inner {
      position: relative;
      border-radius: 10px;
      overflow: hidden;
      box-shadow: 0 5px 20px 0 rgba(0, 0, 0, .1);
      transition: .2s ease-in-out;

      img {
        position: relative;
        display: block;
        width: 200px;
        height: auto;
        border-radius: 10px;
      }
    }

    &__cover {
      position: absolute;
      z-index: 1;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      cursor: pointer;
      display: flex;
      align-items: flex-end;
      justify-content: center;
      background: rgba(0, 0, 0, .6);
      opacity: 0;
      transition: opacity .2s ease-in-out;

      i {
        font-size: 2.3rem;
        transform: translateY(120px);
        transition: transform .4s ease-in-out;
      }
    }

    &:hover {
      .current-image__inner {
        box-shadow: 0 0 0 white;
        transform: scale(.99);
      }

      .current-image__cover {
        opacity: 1;

        i {
          transform: translateY(-20px)
        }
      }
    }
  }

  .file {
    width: 200px;
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    &__icon {
      font-size: 8rem;
    }
  }

  // sizes
  .custom-upload-file.size-sm {
    .upload-file {
      width: 100px;
      height: 100px;
    }

    .current-image__cover i {
      font-size: 1.5rem;
    }

    .current-image__inner img {
      width: 100px;
    }

    .con-img-upload .img-upload,
    .con-input-upload {
      width: 100px;
      height: 100px;
    }

    .file {
      width: 100px;
      height: 100px;

      &__icon {
        font-size: 4rem;
      }
    }
  }
</style>
